// extracted by mini-css-extract-plugin
export default {"anchor":"PrimaryImageWrapper_anchor__joQOD","badge":"PrimaryImageWrapper_badge__2VUWJ","faded":"PrimaryImageWrapper_faded__G2LXZ"};